import React, { useEffect } from 'react';
import App from './App';
import CooDashboardPage from './views/coo-dashboard/CooDashboardPage';
import PocDashboardPage from './views/poc/PocDashboardPage';
import ChatbotPage from './views/chatbot/ChatbotPage';
import {
  AUTH_TARGETS,
  COO_DASHBOARD_PATH,
  readStoredAuthState,
} from './constants/authConfig';

const POC_PATH = '/poc';
const CHATBOT_PATH = '/chatbot';

export function resolveRootView(pathname = '/', authState = readStoredAuthState()) {
  const normalizedPath = pathname === '/' ? '/' : (pathname || '/').replace(/\/+$/, '') || '/';
  const isCooSession = authState.isAuthenticated && authState.target === AUTH_TARGETS.cooDashboard;

  if (normalizedPath === COO_DASHBOARD_PATH) {
    return isCooSession ? 'coo-dashboard' : 'app';
  }

  if (normalizedPath === POC_PATH) {
    return 'poc';
  }

  if (normalizedPath === CHATBOT_PATH) {
    // Chatbot is gated behind the same COO access (aerial2026). Unauthenticated
    // visitors fall through to the login (App) page.
    return isCooSession ? 'chatbot' : 'app';
  }

  return 'app';
}

export default function RootRouter({ pathname = typeof window !== 'undefined' ? window.location.pathname : '/' }) {
  const authState = readStoredAuthState();
  const rootView = resolveRootView(pathname, authState);

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const currentPath = window.location.pathname === '/'
      ? '/'
      : (window.location.pathname || '/').replace(/\/+$/, '') || '/';

    if (rootView === 'app' && currentPath === COO_DASHBOARD_PATH) {
      window.history.replaceState(null, '', '/');
    }

    // When /chatbot is hit without a COO session, bounce to root so the login
    // renders with a clean URL instead of stranding the user on /chatbot.
    if (rootView === 'app' && currentPath === CHATBOT_PATH) {
      window.history.replaceState(null, '', '/');
    }
  }, [rootView]);

  if (rootView === 'coo-dashboard') return <CooDashboardPage />;
  if (rootView === 'poc') return <PocDashboardPage />;
  if (rootView === 'chatbot') return <ChatbotPage />;
  return <App />;
}
